import { AcubePaymentDirection, PaymentStatus } from '@repo/database/browser';
import z from '@/lib/zod';
import { SEPA_ADMIN_PROVIDERS } from '@/pages/acube-payments/lib/filter-params';
import { PAYMENT_DETAIL_TABS } from '@/pages/acube-payments/lib/payment-detail-tabs';
import { commonSearchSchema } from './commonSearchSchema';
import { optionalSearchString } from './search-param-schemas';

/**
 * Filtri delle due liste della pagina: il registro ACube (direzione,
 * collegamento, date) e la lista dei bonifici senza registro (provider,
 * stato), più la scheda del dettaglio. Gli enum si validano qui; ogni lista manda all'API solo i propri
 * (`lib/filter-params.ts`), così un URL sbagliato perde il filtro invece di
 * produrre un 400.
 */
export const acubePaymentsSearchSchema = commonSearchSchema.extend({
  subTab: optionalSearchString(),
  tenantId: optionalSearchString(),
  direction: z.enum(AcubePaymentDirection).nullish().catch(undefined),
  linked: optionalSearchString(),
  dateFrom: optionalSearchString(),
  dateTo: optionalSearchString(),
  provider: z.enum(SEPA_ADMIN_PROVIDERS).nullish().catch(undefined),
  status: z.enum(PaymentStatus).nullish().catch(undefined),
  /** Scheda del dettaglio aperto (assente = Riepilogo). */
  tab: z.enum(PAYMENT_DETAIL_TABS).nullish().catch(undefined),
});

export type AcubePaymentsSearch = z.output<typeof acubePaymentsSearchSchema>;
